export default class HttpError extends Error {
  status: number

  response: any

  // eslint-disable-next-line
  constructor(response, status) {
    super('Http error')
    this.name = 'HttpError'
    this.response = response
    this.status = status
  }
}
